import React from "react";
import { uri } from "../../../help/Api";
import { useEffect } from "react";
import BackdropScI from "../../../services/BackdropScI";
import useFetchURL from "../../../components/Hooks/useFetchURL";
import DFSettingsForm from "./default-settings-form";
import DefaultSettings from "./default-settings";
import { sto } from "../../../Context/InshData";
// import Safes from "./safes";

export default function DefaultSettingsCon() {
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
        Urls = 'SysSettings'
    } else {
        Urls = `/SysSettings?db_name=${sto?.db_name}`
    }
    const url = uri + Urls;

    const { data, fetching, fetchURL } = useFetchURL({
        ...{
            url,
        }
    });

    useEffect(() => {
        console.log('data  is', data)
    })

    if (fetching || !data)
        return <BackdropScI />
    return (
        <DefaultSettings {
            ...{
                data,
                fetchURL,
            }
        } />
    )
}

